module.exports = __webpack_public_path__ + "img/spezialisierungen_1920.94688d17.jpg";